export const NavEvents = {
  RELOAD: 'reload-nav'
};
